export enum Roles {
  BUYER = 'BUYER',
  COMMERCE = 'COMMERCE',
  ADMIN_COMMERCE = 'ADMIN_COMMERCE',
  UNKNOW = 'UNKNOW'
}
export default Roles;
